import styled from '@emotion/styled';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Box, Text } from 'roo-ui/components';
import { themeGet } from 'styled-system';
import { getTravelArranger, getProperty } from 'store/booking/bookingSelectors';
import { useDataLayer } from 'hooks/useDataLayer';
import { CONTACT_US } from 'config';
import AppLink from 'components/AppLink';

const InlineLink = styled(AppLink)`
  color: ${themeGet('brand.primary')};
  text-decoration: underline;
`;

const BookingOverview = () => {
  const { email: emailAddress } = useSelector(getTravelArranger);
  const { name: propertyName } = useSelector(getProperty);
  const { emitInteractionEvent } = useDataLayer();

  const handleContactUsClicked = useCallback(() => {
    emitInteractionEvent({ type: 'Contact Us Link', value: 'Link Selected' });
  }, [emitInteractionEvent]);

  return (
    <Box borderBottom={[1, 0]} borderColor="greys.alto" pb={[6, 3]} data-print-style="paragraph">
      <Text fontSize={['sm', 'base']} data-testid="property-name">
        We have made your reservation at {propertyName}.{`  `}A confirmation email has been sent to
      </Text>
      <Text fontSize={['sm', 'base']} data-testid="arranger-email" fontWeight="bold">
        {`  ${emailAddress}.  `}
      </Text>
      <Text fontSize={['sm', 'base']} display={['inline-block', 'inline']} pt={[4, 0]} data-print-style="hidden">
        If you have any questions about your booking please
        <InlineLink
          fontSize={['sm', 'base']}
          to={CONTACT_US}
          ml={1}
          onClick={handleContactUsClicked}
          data-testid="contact-us"
          target="_blank"
          aria-label="View contact us page (opens in a new tab)"
        >
          {'  '}contact us
        </InlineLink>
        .
      </Text>
    </Box>
  );
};

BookingOverview.displayName = 'BookingOverview';

export default BookingOverview;
